document.addEventListener("hanlde_cart_event", async(evt) => {
  const addedItem = evt.detail.product;
  let variantId= addedItem.variant_id;

  const fetchVariantDetail = await fetch(`https://ship.heirloomroses.com/api/product-type?variant_id=${variantId}`,{
    headers: {'Content-Type': 'application/json'}
  });
  const variantDetail = await fetchVariantDetail.json();

  const check = await isValidateForPreOrder(variantDetail.data.product);

  if (variantDetail.data.product.action_name == 'Preorder' && check) {
    let lineItemKey = addedItem.key

    const updateLineItemReq = await fetch(`/cart/change.js`,{
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: lineItemKey,
        properties:{
          Message: "This is a pre-order item"
        }
      })
    });

    const updatedLineItemRes = await updateLineItemReq.json();
  }

  function isValidateForPreOrder(config){

      if(!config.start_date || !config.end_date) return false;

      const date = new Date();
      let dateFrom = config.start_date.split('T')[0].replace(/-/g,'/');
      let dateTo = config.end_date.split('T')[0].replace(/-/g,'/');
      let currnetDate = `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`;

      let dateFromParse = dateFrom.split("/");
      let dateToParse = dateTo.split("/");
      let currentDateParse = currnetDate.split("/");

      let from = new Date(dateFromParse[0], parseInt(dateFromParse[1])-1, dateFromParse[2]);  // -1 because months are from 0 to 11
      let to   = new Date(dateToParse[0], parseInt(dateToParse[1])-1, dateToParse[2]);
      let check = new Date(currentDateParse[2], parseInt(currentDateParse[1])-1, currentDateParse[0]);

      return check >= from && check <= to && config.action_name == 'Preorder';
    }
})